const SCALAR_URL = process.env.REACT_APP_SCALAR_URL;

export default function imageUrl(name) {
    return `${SCALAR_URL}${name}`;
}
